export default __webpack_public_path__ + "static/media/rt-tony-img-min.fc6e6d8b.png";